import React, {
    useLayoutEffect,
    useRef
} from 'react';
import { slick } from "@accessible360/accessible-slick";

import TicketCard from './ticket-card';

const above_breakpoint = window.matchMedia("(min-width: 75em)").matches;

export default function CardCarousel(props) {
    
    const containerRef = useRef(null);
    const is_carousel = props.cards?.length > 2;
    
    useLayoutEffect(() => {
        if (!is_carousel || !containerRef.current || !above_breakpoint) return;

        // Wait for DOM to render
        const timeout = setTimeout(() => {
            const carousel = containerRef.current;
            if (!carousel) return;

            const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M10.6 21.3a1 1 0 0 1-1-1V3.4l-7.9 8A1 1 0 0 1 .3 9.8L9.9.3a1 1 0 0 1 1.4 0L21 9.9a1 1 0 0 1-1.5 1.4l-7.9-7.9v16.9c0 .5-.4 1-1 1Z" clip-rule="evenodd"/></svg>`;
            
            const slickProps = {
                dots: false,
                arrows: true,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                adaptiveHeight: false,
                arrowsPlacement: "afterSlides",
                prevArrow: '<button type="button" data-control-prev><span class="sr-text">Previous</span>' + arrow + "</button>",
                nextArrow: '<button type="button" data-control-next><span class="sr-text">Next</span>' + arrow + "</button>",
            };

            $(carousel).slick(slickProps);
        }, 0);

        return () => clearTimeout(timeout);
    }, [props.cards, containerRef.current]);

    return (        
        <section className={`${props.class} card-carousel__container`}>
            <header>
                <h2 className='booking-pathway__header'>{props.title}</h2>
            </header>

            <div ref={containerRef} className={`${props.class}__cards card-carousel ${!is_carousel ? "not-carousel" : "is-carousel"}`}>
                <div  className={`${props.class}__cards--item card-carousel__item`}>
                    {props.cards.map(ticket => (
                        <TicketCard key={ticket.id} event={ticket} type="upcoming" />
                    ))}
                </div>
            </div>
        </section>
    );
}
